import { render, staticRenderFns } from "./capacitacion-induccion.vue?vue&type=template&id=3b08a08e&scoped=true&"
import script from "./capacitacion-induccion.vue?vue&type=script&lang=js&"
export * from "./capacitacion-induccion.vue?vue&type=script&lang=js&"
import style0 from "./capacitacion-induccion.vue?vue&type=style&index=0&id=3b08a08e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08a08e",
  null
  
)

export default component.exports